export const MONTHLY_SIGHTINGS_TITLE = 'Sighting Activity';
export const RECENT_YEARS_COUNT = 5;
